// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st3[data-v-1f5e26ba] {\n  fill: #23286b;\n}\n.st4[data-v-1f5e26ba] {\n  fill: #a1e7fc;\n}\n.st5[data-v-1f5e26ba] {\n  fill: #1A7BEE;\n}\n.st9[data-v-1f5e26ba] {\n  fill: #fff;\n}\n.st18[data-v-1f5e26ba] {\n  fill: #e94766;\n}\n.st21[data-v-1f5e26ba] {\n  fill: #85d7ea;\n}\n.st31[data-v-1f5e26ba] {\n  fill: #ffbeb6;\n}\n", ""]);
// Exports
module.exports = exports;
